module.exports = __webpack_public_path__ + "static/media/current_courses.757cda52.jpg";